/**
 * 「延迟才置真」的开关（21aa）。
 *
 * 用处：加载态 UI 只在**真的要等**的时候才出现。打开会话时如果本地已有消息，
 * `rows` 下一帧就有了（零 HTTP 路径），这时闪一下骨架比一直空着更难看；
 * 只有本地没有、要等网络那几百毫秒，骨架才有意义。
 *
 * `active` 转 false 时**立即**归零（内容到了要马上让位），不走延迟。
 *
 * 没写单测：仓库里没有 @testing-library（组件/hook 一律由 e2e 覆盖，
 * 单测只测纯函数），不值得为这十行引一个依赖。行为由
 * `e2e/chat-window.spec.ts` 的「慢响应出骨架 / 快路径不闪」两条钉住。
 */
import { useEffect, useState } from 'preact/hooks';

export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!active) {
      setOn(false);
      return;
    }
    const t = window.setTimeout(() => setOn(true), delayMs);
    return () => window.clearTimeout(t);
  }, [active, delayMs]);
  return on;
}
